/* unplugin-vue-components disabled */import { render } from "./sort-dropdown.vue?vue&type=template&id=1c699c1c&scoped=true&ts=true"
import script from "./sort-dropdown.vue?vue&type=script&lang=ts"
export * from "./sort-dropdown.vue?vue&type=script&lang=ts"

import "./sort-dropdown.vue?vue&type=style&index=0&id=1c699c1c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c699c1c"]])

export default __exports__